<template>
  <div class="max-w-main bg-vmain ">
    <div class="logo_web">
        <img class="ml-8 h-8 cursor-pointer" @click="$router.push('/')" src="../../assets/logo_web.png" >
    </div>
    <div class="p-3">
        <div class="bc-detail">
            <!-- <b-breadcrumb :items="items"></b-breadcrumb> -->
            <b-breadcrumb>
                <b-breadcrumb-item @click="$router.push('/')" >Trang chủ</b-breadcrumb-item>
                <b-breadcrumb-item @click="$router.push('/blog')">Blog</b-breadcrumb-item>
                <b-breadcrumb-item active>{{ data.category_name }}</b-breadcrumb-item>
            </b-breadcrumb>
        </div>
        <div class="text-2xl font-bold">
            {{data.name}}
        </div>

         <div style="color: grey;" class="mt-2">
            <div class="grid grid-cols-2">
                <div>{{ data.category_name }}</div>
                <div class="text-right">{{ data.updated_time | toDMY }}</div>
            </div>
        </div>

        <div class="content-detail mgt-20 mt-4">
            <div v-html="data.content"></div>
        </div>

        <div class="tag">
            <div class="fw-700 ft-16">
                Tags
            </div>
            <div class="mgt-10 tag-contents">
                <span style="margin-right: 10px; height: 30px;" v-for="(i) in tags"
                        :key="i">
                    <span class="active-btn category-btn main-center pd-5 mgt-10">
                        {{ i }}
                    </span>
                    <!-- <span @click="changeCategory(index,i.id)" v-else class="category-btn main-center content-box-app pd-5 mgt-10">
                        {{ i }}
                    </span> -->
                </span>
            </div>
        </div>

        <div class="mg-t20" style="border-top: 1px solid #EBECED; color: white; height: 1px;">.</div>

        <div class="mgt-20 blog-new">
            <div class="fw-700 ft-16 title_category">
                Bài viết mới
            </div>
            <div>
                <div class="grid grid-cols-3 gap-4" v-for="item in news" :key="item.id">
                    <div @click="viewDetail(item.id,item.slug)" class="..."><img style="border-radius: 5px;height: 100px;" class="cursor-pointer" :src="item.image" ></div>
                    <div @click="viewDetail(item.id,item.slug)" class="col-span-2 cursor-pointer">
                        <div class="fw-700 ft-16">
                            {{item.name}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mgt-20 blog-new">
            <div class="fw-700 ft-16 title_category">
                Bài viết liên quan
            </div>
            <div>
                <div class="grid grid-cols-3 gap-4" v-for="item in refer" :key="item.id">
                    <div @click="viewDetail(i.id,i.slug)" class="cursor-pointer"><img style="border-radius: 5px;height: 100px;" :src="item.image" ></div>
                    <div @click="viewDetail(i.id,i.slug)" class="col-span-2 cursor-pointer">
                        <div class="fw-700 ft-16">
                            {{item.name}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-mo></footer-mo>
        <!-- <b-container class="content-box-app">
            <footer-mo></footer-mo>
        </b-container> -->
    </div>
  </div>
</template>

<script>
import FooterMo from '../footer/index.vue'
import { getDetailBlog,getNewBlog,getReferenceBlog } from '@/api/otp'

export default {
    components: { FooterMo },
    data(){
        return{
            total: 100,
            currentPage: 1,
            data: {},
            tags: ['Tài chính','Vay tiền'],
            news: [],
            refer: [],
            items: [
            {
                text: 'Trang chủ',
                href: '/v2/'
            },
            {
                text: 'Blog',
                href: '/v2/blog'
            },
            {
                text: 'Tài chính cá nhân',
                active: true
            }
            ],
            c_active: 0,
        }
    },
    methods: {
        fetchData(){
            getDetailBlog({slug: this.$route.params.slug}).then(res => {
                this.data = res.data
                this.tags = res.data.tags
            })
        },
        viewDetail(id,slug){
            //this.$router.push('/blog/chi-tiet/' +id +'/'+slug)
            this.$router.push('/'+slug+'.html')
        },
        fetchNews(){
            getNewBlog({slug: this.$route.params.slug}).then(res => {
                this.news = res.data
            })
        },
        fetchRe(){
            getReferenceBlog({slug: this.$route.params.slug}).then(res => {
                this.refer = res.data
            })
        }
    },
    created(){
        this.fetchData()
        this.fetchNews()
        this.fetchRe()
    }
}
</script>

<style>
.logo_web {
    padding-top: 2%;
    margin-bottom: 35px;
}
.blog-new .title_category {
    margin-bottom: 10px;
}
.logo_web img {
    margin-left: 15px;
}
.mgt-30 {
    padding-left: 15px;
    padding-right: 15px;
}
.bc-detail a {
    color: black;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    color: black;
    margin-left: 5px;
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 8px !important;
    min-width: 33.8px;
}

.page-item.active .page-link {
    z-index: 3;
    color: #F1674A;
    background-color: #FEF0ED;
    border-color: #F1674A;
}
.content-detail {
    font-style: normal;
    font-weight: 400;
    font-size: 19px;
    line-height: 165%;
    letter-spacing: -0.03em;
    color: #34404B;
}
.content-detail img {
    max-width: 100%;
    height: auto;
}
.tag {
    margin-top: 20px;
}
.tag .fw-700 {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 133%;
    letter-spacing: -0.03em;
    color: #34404B;
}
.tag .tag-contents {
    margin-top: 20px;
    margin-bottom: 20px;
}
.tag .tag-contents span {
    padding: 8px;
    background: #EBECED;
    border-radius: 16px;
}
.blog-new {
    margin-top: 40px;
}
.blog-new .fw-700 {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 133%;
    letter-spacing: -0.03em;
    color: #34404B;
}
.blog-new .col-span-2 .fw-700 {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 133%;
    letter-spacing: -0.03em;
    color: #34404B;
}
.blog-new .grid-cols-3 {
    margin-bottom: 15px;
    align-items: center;
}
.blog-new .grid-cols-3 img{
    width: 100%;
}
</style>